import { authorizationHeader } from '@picsart/growth-rc/services/auth';

import { getContext } from '@/context';
import { getAccessToken } from '@/utils/user/getAccessToken';

type Status = 'COMPLETED' | 'FAILED' | 'PENDING' | 'PROCESSING';

type ResultMediaType = 'image' | 'video' | 'IMAGE' | 'VIDEO';

type IResult = {
  type: ResultMediaType;
  driveUid?: string;
  result: {
    url: string;
    metadata?: {
      width: number;
      height: number;
    };
    frames?: {
      first?: string;
      last?: string;
    };
  };
};

type PollResponse = {
  response: {
    status: Status;
    output?: {
      url: string;
    };
    result?: Array<IResult>;
  };
};

const pollRequest = async (url: string): Promise<PollResponse> => {
  const response = await getContext().utils.api.fetch(url, {
    headers: {
      ...authorizationHeader(getAccessToken()),
      'Content-Type': 'application/json',
    },
  });

  const body = await response.json();
  if (!response.ok) {
    throw new Error(
      `Error: ${response.status} ${body.message || response.statusText}`
    );
  }
  return body;
};

export { pollRequest };
export type { PollResponse, Status, IResult, ResultMediaType };
